import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0013',
    ecrans: ['00-2'],
    params: ['catcleint', 'catcod', 'catdsc', 'peccod']
});
